import type { SVGProps } from "react";
export default function SvgCalendar(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-calendar-icon lucide-calendar"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M8 2v4" />
			<path d="M16 2v4" />
			<rect width={18} height={18} x={3} y={4} rx={2} />
			<path d="M3 10h18" />
		</svg>
	);
}
